import { render, staticRenderFns } from "./UMLSubController.vue?vue&type=template&id=3f381fa6&scoped=true&"
import script from "./UMLSubController.vue?vue&type=script&lang=js&"
export * from "./UMLSubController.vue?vue&type=script&lang=js&"
import style0 from "./UMLSubController.vue?vue&type=style&index=0&id=3f381fa6&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f381fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
